import { Link, useNavigate } from "react-router-dom";
import { logout } from "../lib/auth/actions";
import { useSession } from "../lib/auth/useSession";
import { env } from "../lib/env";

// The shell's body for an org whose recipe resolves to no dashboard
// surface (lib/capabilities' lacksDashboardSurface — an asset-rooted
// vertical with no `dashboards`, e.g. residential_rental today). Shell
// renders it in place of the routed screen and OverviewRoute uses it as
// its own "no board" fallback, so the user never sees facility copy or
// an empty Dashboard frame. Every way out is kept: the platform panel for
// BitácoraPro staff, the PWA (where this vertical works today) and
// logout. Never keyed on recipe.slug (ADR-0072).
export function NoDashboardSurface() {
  const session = useSession();
  const navigate = useNavigate();
  const isPlatformAdmin = session?.user.platformAdmin === true;
  const pwaUrl = env.pwaBaseUrl;

  async function handleLogout() {
    await logout();
    navigate("/login", { replace: true });
  }

  return (
    <div className="page">
      <header className="page-header">
        <div className="page-header__lead">
          <h1 className="page-header__title">Tu cuenta aún no tiene panel de gestión</h1>
          <p className="page-header__sub">
            El panel de escritorio todavía no está disponible para tu tipo de operación. Mientras
            tanto, sigue trabajando desde la app en tu teléfono.
          </p>
        </div>
        <div className="page-header__actions">
          {isPlatformAdmin && (
            <Link to="/admin" className="btn btn--primary btn--sm">
              Ir a administración
            </Link>
          )}
          {pwaUrl !== undefined && (
            <a
              href={pwaUrl}
              className={`btn btn--sm ${isPlatformAdmin ? "btn--secondary" : "btn--primary"}`}
            >
              Volver a la app
            </a>
          )}
          <button
            type="button"
            className="btn btn--secondary btn--sm"
            onClick={() => void handleLogout()}
          >
            Cerrar sesión
          </button>
        </div>
      </header>
    </div>
  );
}
